<template>
  <div>
    <p class="mb-0" style="cursor: default">
      {{ item.number || '-' }}
    </p>
    <small class="d-block">
      <span class="has-tip" data-title="Sale Price" v-html="getPrices(item.sale_price)"></span>
    </small>
    <small class="d-block">
      <span class="has-tip" data-title="Purchase Price" v-html="getPrices(item.purchase_price)"></span>
    </small>
  </div>
</template>

<script>
export default {
  computed: {
    extraAttributes() {
      return this.config?.extraAttributes || {}
    },
    currency() {
      let currency = Object.assign({}, this.extraAttributes?.currency || {})
      currency.purchase = Object.assign({}, currency?.purchase || {}, {
        '': {
          label: ''
        }
      })
      return currency
    },
    row() {
      return this.config?.row || {}
    },
    item() {
      return this.row[this.config?.key] || {}
    }
  },
  methods: {
    getPrices(items) {
      let prices = []
      if (_.isObjectLike(items)) {
        Object.entries(items).forEach(([currency, price]) => {
          if (price > 0) {
            prices.push(`${parseFloat(parseFloat(price).toFixed(2))}${this.currency.sale[currency] != undefined ? this.currency.sale[currency].label : currency}`)
          }
        })
      }
      return prices.join(' - ')
    }
  },
  props: {
    config: Object
  }
}
</script>
